import PropTypes from "prop-types";
import { Container, Link } from "@mui/material";
import { isEmpty } from "ramda";
import { NavLink } from "react-router-dom";

import musicIconSvg from "assets/images/Music.svg";
import StarringYouCards from "components/StarringYouCards";
import { appRoutes } from "routes";

import { MusicLogo, Title, Info, CardContainer } from "./styles";

const MusicVideos = ({ items, loading }) => {
  return (
    <Container align="center">
      <MusicLogo src={musicIconSvg} alt="Music Videos icon" width={200} />
      <Title variant="h1">Music Videos</Title>
      <Info align="center" spacing={isEmpty(items)}>
        Fresh Hits, Golden Oldies, Flashback Favorites... JibJab is the place to stick your face in the popular music
        videos with your favorite{" "}
        <Link exact to={appRoutes.categoryPath("music-video-ecards")} component={NavLink}>
          artists
        </Link>
        .
      </Info>
      <CardContainer>
        {!isEmpty(items) && <StarringYouCards items={items} title={null} loading={loading} center />}
      </CardContainer>
    </Container>
  );
};

MusicVideos.propTypes = {
  loading: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({})),
};

export default MusicVideos;
